// extracted by mini-css-extract-plugin
export default {"dialog":"U1pvEd7WRFsBBgBl","title":"tCvQqjqWjCwFIaj0","top":"PmHzzF2gHkoCYLwx","main":"n56Sk69OJkFLq5Kr","bids":"nnLj_vE8g0g9NG5j","button":"B1f9ZJAmd_ILB7qz"};